import AxiosInstance from "../config/AxiosInstance";

const loadEmploy = async (filter: any) => {
    try {
        const { data } = await AxiosInstance.post('/api/employees/list', filter);
        return { data };
    } catch (error) {
        throw error;
    }
}

const createEmploy = async (payload: any) => {
    try {
        const { data } = await AxiosInstance.post('/api/employees', payload);
        return { data };
    } catch (error) {
        throw error;
    }
}
const getDetailsEmploy = async (id: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/employees/' + id);
        return { data };
    } catch (error) {
        throw error;
    }
}
const updateDetailsEmploy = async (id: any, payload: any) => {
    try {
        const { data } = await AxiosInstance.put('/api/employees/' + id, payload);
        return { data };
    } catch (error) {
        throw error;
    }
}
const deleteEmployee = async (id: any) => {
    try {
        const { data } = await AxiosInstance.delete('/api/employees/' + id);
        return { data };
    } catch (error) {
        throw error;
    }
}
export {
    loadEmploy,
    createEmploy,
    getDetailsEmploy,
    updateDetailsEmploy,
    deleteEmployee
}